export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const extractFileId = (viewLink) => {
    try {
        if (!viewLink) return null;

        const match = viewLink.match(/\/file\/d\/([^/]+)/);
        return match ? match[1] : null;

    } catch (error) {
        console.error('Error extracting file ID:', error);
        return null;
    }
};

export const QUESTION_TYPES = {
    SINGLECHOICE:"Single Choice",
    YESNO:"Yes/No",
    YESNOTEXT:"Yes/No + Text",
    YESNONOTAPPLICABLE:"Yes / No /Not Applicable",
    TEXT:"Text",
    NUMERIC100:"numeric value from -100 to 100",
    NUMERICVALUE:"numeric value",
    SINGLECHOICETEXT:"Single Choice + Text"
}